// extracted by mini-css-extract-plugin
export default {"heading":"StableDetails_heading__cwTTj"};